import { Stack } from '@mui/material'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { CartHeaderH1, CartHeaderSeparator } from '../CartContent/CartHeader'
import { useAppSelector } from '../../Common/_hooks/useAppSelector'
import { selectCarts } from '../../UserData/_selectors/OrderSelectors'
import CheckoutShipping from '../../Checkout/Shipping/CheckoutShipping'
import { buildGoogleItems } from '../../Common/Tracking/CartTracking'
import { buildMetaCartPayload, getMetaCheckoutEventId, queueMetaServerEvent, trackMetaBrowserEvent } from '../../Common/Tracking/MetaConversions'
import { queueOpenAIAdsServerEvent, trackOpenAIAdsCheckoutStarted } from '../../Common/Tracking/OpenAIAdsTracking'

export default function CartShipping() {
  const [t] = useTranslation('cart')
  const [tR] = useTranslation('routes')

  const carts = useAppSelector(selectCarts)
  const trackedInitiateCheckout = useRef(new Set<string>())

  useEffect(() => {
    carts.forEach(cart => {
      if (trackedInitiateCheckout.current.has(cart.get('ref_id'))) {
        return
      }

      trackedInitiateCheckout.current.add(cart.get('ref_id'))
      const eventId = getMetaCheckoutEventId('InitiateCheckout', cart)
      const metaPayload = buildMetaCartPayload(cart)

      trackMetaBrowserEvent('InitiateCheckout', cart, eventId)
      queueMetaServerEvent('InitiateCheckout', cart, eventId)
      trackOpenAIAdsCheckoutStarted(cart, eventId)
      queueOpenAIAdsServerEvent('checkout_started', cart, eventId)

      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      window.gtag && window.gtag('event', 'begin_checkout', {
        currency: metaPayload.currency,
        value: metaPayload.value,
        items: buildGoogleItems(cart)
      })
    })
  }, [carts])

  return <Stack spacing={2}>
    <CartHeaderH1><Link to={tR('/cart')}>{t('Cart')}</Link> <CartHeaderSeparator /> <span className="title">{t('Shipping')}</span></CartHeaderH1>
    <div>
      <CheckoutShipping
        orders={carts}
        paymentUrl={tR('/cart/payment')}
      />
    </div>
  </Stack>
}
